import React from 'react';

import exampleWorkbookUrl from '../example/proteorisk-example-workbook.xlsx';
import { BODY_SYSTEMS } from './report/bodySystems';

// A synthetic Olink Explore HT workbook in exactly the layout the pipeline
// reads (sheet Data; DAid, barcode, Cohort, Diagnose, then one column per
// protein; one sample row). Its values are made up: the same synthetic sample
// as the example report. Scored as a 58-year-old man with BMI 29.4, it gives
// exactly that report (checked with the olink-proteomics 2.0.0 script).
export const EXAMPLE_WORKBOOK = Object.freeze({
  url: exampleWorkbookUrl,
  filename: 'proteorisk-example-workbook.xlsx',
  age: 58,
  sex: 'Male',
  bmi: 29.4,
});

export function ExampleWorkbookLink({ children = 'Download the example workbook', className = 'PROTEORISK-link' }) {
  return (
    <a href={EXAMPLE_WORKBOOK.url} download={EXAMPLE_WORKBOOK.filename} className={className}>
      <i className="fas fa-file-download" aria-hidden="true" /> {children}
    </a>
  );
}

// The body systems wheel of the example report, for illustrations.
const EXAMPLE_STATUSES = Object.freeze({
  circulatory: 'high', metabolic: 'high', digestive: 'moderate', musculoskeletal: 'moderate', multisystem: 'high',
});
export const EXAMPLE_WHEEL = Object.freeze(BODY_SYSTEMS.map((system) => ({
  ...system, status: EXAMPLE_STATUSES[system.code] || 'typical',
})));
